import { K8sProviderIcon } from '@cast/features-cluster-ui';
import { PropsWithChildren } from 'react';

import {
  DialogTitle,
  mergeSx,
  SxProps,
  Stack,
  tokens,
} from '@cast/design-system';

import { Cluster } from 'types/cluster';

import { ClusterDialogHeaderActions } from '../ClusterDialogHeaderActions';
import { ClusterDialogTitle } from './ClusterDialogTitle';

type DialogHeadingProps = PropsWithChildren<{
  onClose: () => void;
  sx?: SxProps;
  hideTerraformLink?: boolean;
}>;

export const DialogHeading = ({
  children,
  onClose,
  sx,
  hideTerraformLink,
}: DialogHeadingProps) => {
  return (
    <DialogTitle sx={mergeSx({ p: '16px 24px' }, sx)} component="div">
      <Stack direction="row" justifyContent="space-between">
        {typeof children === 'string' ? (
          <ClusterDialogTitle>{children}</ClusterDialogTitle>
        ) : (
          children
        )}

        <ClusterDialogHeaderActions
          onClose={onClose}
          hideTerraformLink={hideTerraformLink}
        />
      </Stack>
    </DialogTitle>
  );
};

type ClusterDialogHeadingProps = {
  cluster: Cluster;
  onClose: () => void;
};

export const ClusterDialogHeading = ({
  cluster,
  onClose,
}: ClusterDialogHeadingProps) => {
  return (
    <DialogHeading
      onClose={onClose}
      sx={{ borderBottom: tokens.theme.border.structural.neutral }}
    >
      <Stack direction="row" alignItems="center" gap={8} flexWrap="nowrap">
        <K8sProviderIcon provider={cluster.providerType} size={24} />
        <ClusterDialogTitle>{cluster.name}</ClusterDialogTitle>
      </Stack>
    </DialogHeading>
  );
};
